/*
 * Generated type guards for "configuration.ts".
 * WARNING: Do not manually change this file.
 */
import { IPaymentSettingsResponse, ICartSettingsResponse, IDeliverySettingsResponse, IServiceSettingsResponse, IFeatureSettingsResponse, IBenefitSettingsResponse, IBenefitFreeDeliverySettings, IBenefitCountryOptionsResponse } from "./configuration";
import { EServiceGroupName } from "../../../../model/settings/cartSettings";

export function isPaymentSettings(obj: any, _argumentName?: string): obj is IPaymentSettingsResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        (obj.payPal !== null &&
            typeof obj.payPal === "object" ||
            typeof obj.payPal === "function") &&
        (obj.payPal.clientId === null ||
            typeof obj.payPal.clientId === "string") &&
        typeof obj.payPal.expressCheckout === "boolean" &&
        (obj.adyen !== null &&
            typeof obj.adyen === "object" ||
            typeof obj.adyen === "function") &&
        typeof obj.adyen.clientKey === "string" &&
        typeof obj.adyen.merchantAccount === "string" &&
        typeof obj.adyen.applePayMerchantName === "string" &&
        typeof obj.adyen.applePayMerchantId === "string" &&
        typeof obj.adyen.googlePayEnvironment === "string" &&
        typeof obj.adyen.googlePayMerchantName === "string" &&
        typeof obj.adyen.googlePayMerchantAccountName === "string" &&
        (obj.adyen.googlePayMerchantId === null ||
            typeof obj.adyen.googlePayMerchantId === "string")
    )
}

export function isCartSettings(obj: any, _argumentName?: string): obj is ICartSettingsResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        Array.isArray(obj.serviceSettings) &&
        obj.serviceSettings.every((e: any) =>
            isServiceSettings(e) as boolean
        ) &&
        Array.isArray(obj.settings) &&
        obj.settings.every((e: any) =>
            isFeatureSettings(e) as boolean
        )
    )
}

export function isDeliverySettings(obj: any, _argumentName?: string): obj is IDeliverySettingsResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.freeDeliveryEnabled === "boolean" &&
        obj.freeDeliveryGlobalFrom instanceof Date &&
        typeof obj.freeDeliveryGlobalLimit === "number" &&
        obj.freeDeliveryGlobalTo instanceof Date &&
        Array.isArray(obj.deliveryFeatures) &&
        obj.deliveryFeatures.every((e: any) =>
            isFeatureSettings(e) as boolean
        ) &&
        Array.isArray(obj.deliveryType) &&
        obj.deliveryType.every((e: any) =>
            (e !== null &&
                typeof e === "object" ||
                typeof e === "function") &&
            typeof e.deliveryTypeId === "number" &&
            typeof e.priceLimit === "number"
        )
    )
}

export function isServiceSettings(obj: any, _argumentName?: string): obj is IServiceSettingsResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.id === "number" &&
        typeof obj.name === "string" &&
        typeof obj.isActive === "boolean" &&
        (obj.groupName === EServiceGroupName.GIFT_PACKAGING ||
            obj.groupName === EServiceGroupName.ECO_PACKAGING ||
            obj.groupName === EServiceGroupName.INSURANCE ||
            obj.groupName === EServiceGroupName.ENGRAVING ||
            obj.groupName === EServiceGroupName.FUND_RAISING ||
            obj.groupName === EServiceGroupName.DISCOVERY_BOX) &&
        typeof obj.sortOrder === "number" &&
        (typeof obj.info === "undefined" ||
            obj.info === null ||
            typeof obj.info === "string") &&
        typeof obj.productCode === "string" &&
        typeof obj.orderPerDay === "number" &&
        typeof obj.stockLimit === "number" &&
        typeof obj.stock === "number" &&
        (obj.colorCode === null ||
            typeof obj.colorCode === "string") &&
        (typeof obj.colorIcon === "undefined" ||
            obj.colorIcon === null ||
            typeof obj.colorIcon === "string") &&
        (typeof obj.image === "undefined" ||
            obj.image === null ||
            typeof obj.image === "string") &&
        typeof obj.price === "number" &&
        typeof obj.vat === "number"
    )
}

export function isFeatureSettings(obj: any, _argumentName?: string): obj is IFeatureSettingsResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.id === "number" &&
        typeof obj.name === "string" &&
        typeof obj.value === "string"
    )
}

export function isBenefitSettings(obj: any, _argumentName?: string): obj is IBenefitSettingsResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        isBenefitFreeDeliverySettings(obj.freeDeliverySettings) as boolean
    )
}

export function isBenefitFreeDeliverySettings(obj: any, _argumentName?: string): obj is IBenefitFreeDeliverySettings {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        Array.isArray(obj.countryOptions) &&
        obj.countryOptions.every((e: any) =>
            isBenefitCountryOptions(e) as boolean
        ) &&
        Array.isArray(obj.supportedCountries) &&
        obj.supportedCountries.every((e: any) =>
            typeof e === "string"
        )
    )
}

export function isBenefitCountryOptions(obj: any, _argumentName?: string): obj is IBenefitCountryOptionsResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.minimalOrderPriceThreshold === "number" &&
        typeof obj.orderPriceActivationThreshold === "number"
    )
}
